module.exports = __webpack_public_path__ + "img/1.58dd2ed8.jpg";